/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import InfoModal from './RenovacaoModal/InfoModal'
import { array, bool, object, string } from 'prop-types'
import { updateAssinatura } from '../../../api/renovacao-automatica.servico'
import ProximaRenovacao from './Renovacao/ProximaRenovacao'
import { RenovarAgora } from './Renovacao/RenovarAgora'
import { RegularizarPagamento } from './Renovacao/RegularizarPagamento'
import SaibaMais from './Renovacao/SaibaMais'
import moment from 'moment'

const Container = styled.div`
  position: relative;
`

const RenovacaoAutomatica = ( {
  assinatura,
  isCuradoria,
  nextdata,
  podeRenovar,
  showSaibaMais,
  setDataProximaRenovacaoAutomatica
} ) => {
  const [ showModal, setShowModal ] = useState( false )

  useEffect( () => {
    const { href } = window.location
    if ( href.includes( '/home/renovacao-automatica' ) ) {
      const id = 'renovacao-automatica'
      const yOffset = -50
      const element = document.getElementById( id )
      const yOffsetToMove =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo( { 'behavior': 'smooth', 'top': yOffsetToMove } )
    }
  }, [] )

  function handleBackButtonModal() {
    setShowModal( false )
  }

  function controllRender() {
    if ( assinatura.status === 'Cancelado' ) {
      return
    }
    if ( !moment( nextdata, 'M/YYYY' ).isValid() ) {
      return
    }
    if ( assinatura?.controles?.falhaAoAtualizar ) {
      return <RegularizarPagamento isCuradoria={ isCuradoria } />
    } else if ( podeRenovar ) {
      return (
        <RenovarAgora
          isCuradoria={ isCuradoria }
          nextData={ nextdata }
          selectedDay={ assinatura.dataProximaRenovacaoAutomatica }
          setDays={ newDay => updateAssinatura( assinatura.id, newDay, isCuradoria, nextdata ) }
        />
      )
    } else {
      return (
        <Container id="proxima-renovacao-automatica">
          <ProximaRenovacao
            nextData={ nextdata }
            selectedDay={ assinatura.dataProximaRenovacaoAutomatica }
            setDays={ newDay => {
              setDataProximaRenovacaoAutomatica( newDay, assinatura.id )
              updateAssinatura(
                assinatura.id,
                newDay,
                isCuradoria,
                nextdata
              )
            } }
          />
        </Container>
      )
    }
  }

  return (
    <>
      {controllRender()}

      {showSaibaMais && assinatura?.controles?.falhaAoAtualizar === false ?
        <SaibaMais
          isCuradoria={ isCuradoria }
          onClick={ () => setShowModal( true ) }
        /> : null}

      <InfoModal
        isCuradoria={ isCuradoria }
        nextData={ nextdata }
        onShowModal={ () => handleBackButtonModal() }
        open={ showModal }
        plan={ assinatura.plano }
      />
    </>
  )
}

RenovacaoAutomatica.propTypes = {
  'assinatura': object.isRequired,
  'isCuradoria': bool.isRequired,
  'nextdata': string.isRequired,
  'podeRenovar': bool.isRequired,
  'validDates': array.isRequired
}

export default RenovacaoAutomatica
